import React from 'react'
import { SimpleSelect } from 'react-selectize'
import { Control } from 'react-redux-form'

class SimpleSelectControl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      search: ''
    }
  }

  render() {
    const { model, createFromValue, children, ...rest } = this.props
    const { isOpen } = this.state
    const parent = this

    return (
      <Control.custom
        model={model}
        component={SimpleSelect}
        getValue={e => e}
        isOpen={isOpen}
        theme="bootstrap3"
        mapProps={{
          onValueChange: props => {
            const { onChange } = props

            return e => {
              //sentry had reported some issues where e was undefined
              const value = (e && e.value) || null

              //console.log("Calling onValueChange with", props, value);
              parent.setState({
                search: ''
              })
              onChange(value)
            }
          },
          onOpenChange: props => {
            const delegate = props.onOpenChange
            const { onChange } = props

            return open => {
              //console.log("Setting open to", open);
              parent.setState({
                isOpen: open
              })
              delegate && delegate.onOpenChange(open)
            }
          },
          onSearchChange: props => {
            const { onSearchChange } = props

            return search => {
              parent.setState({
                search
              })
              onSearchChange && onSearchChange(search)
            }
          },
          search: parent.state.search,
          value: props => {
            //console.log("props =", props);
            const { viewValue } = props

            //console.log("state =", parent.state);
            if (props.isOpen) {
              //console.log("showing value as null!")
              return null
            }

            if (createFromValue && viewValue) {
              const created = createFromValue(viewValue)

              //console.log("created =", created);
              return created
            }

            return viewValue
          },
          style: props => {
            return props.style || { width: '100%' }
          }
        }}
        createFromValue={createFromValue}
        {...rest}>
        {children}
      </Control.custom>
    )
  }
}

export default SimpleSelectControl
